import React from 'react';
import { 
  Box, 
  Typography, 
  IconButton, 
  Tooltip, 
  Snackbar,
  Alert,
  Paper
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';

interface PublicUrlDisplayProps {
  url: string | null | undefined;
}

export const PublicUrlDisplay: React.FC<PublicUrlDisplayProps> = ({ url }) => {
  const { copyToClipboard, copied } = useCopyToClipboard();

  if (!url) {
    return null;
  }

  const handleCopy = () => {
    copyToClipboard(url);
  };

  return (
    <>
      <Paper 
        elevation={1} 
        sx={{ 
          p: 2, 
          mt: 2,
          backgroundColor: '#f5f8ff',
          border: '1px solid #0B4598',
          borderRadius: '8px'
        }}
      >
        <Typography variant="body2" color="#0B4598" fontWeight="600" gutterBottom>
          Your custom job posting page is here:
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          mt: 1 
        }}>
          <Typography 
            variant="body2" 
            sx={{ 
              wordBreak: 'break-all',
              flex: 1,
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              color: '#333'
            }}
          >
            {url}
          </Typography>
          <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
            <IconButton 
              size="small" 
              onClick={handleCopy}
              sx={{
                color: copied ? '#13CA82' : '#0B4598',
                '&:hover': {
                  backgroundColor: 'rgba(11, 69, 152, 0.08)'
                }
              }}
            >
              {copied ? (
                <CheckCircleIcon fontSize="small" />
              ) : (
                <ContentCopyIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>
      
      <Snackbar 
        open={copied} 
        autoHideDuration={2000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          severity="success" 
          sx={{ 
            width: '100%',
            '& .MuiAlert-icon': {
              color: '#13CA82'
            }
          }}
        >
          URL copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
}; 